var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.675 12.2L6.55 9.35L4.25 7.5H7.1L8 4.7L8.9 7.5H11.75L9.425 9.35L10.3 12.2L8 10.425L5.675 12.2ZM2 21.5V13.775C1.36667 13.075 0.875 12.275 0.525 11.375C0.175 10.475 0 9.51667 0 8.5C0 6.26667 0.775 4.375 2.325 2.825C3.875 1.275 5.76667 0.5 8 0.5C10.2333 0.5 12.125 1.275 13.675 2.825C15.225 4.375 16 6.26667 16 8.5C16 9.51667 15.825 10.475 15.475 11.375C15.125 12.275 14.6333 13.075 14 13.775V21.5L8 19.5L2 21.5ZM8 14.5C9.66667 14.5 11.0833 13.9167 12.25 12.75C13.4167 11.5833 14 10.1667 14 8.5C14 6.83333 13.4167 5.41667 12.25 4.25C11.0833 3.08333 9.66667 2.5 8 2.5C6.33333 2.5 4.91667 3.08333 3.75 4.25C2.58333 5.41667 2 6.83333 2 8.5C2 10.1667 2.58333 11.5833 3.75 12.75C4.91667 13.9167 6.33333 14.5 8 14.5ZM4 18.525L8 17.5L12 18.525V15.425C11.4167 15.7583 10.7875 16.0208 10.1125 16.2125C9.4375 16.4042 8.73333 16.5 8 16.5C7.26667 16.5 6.5625 16.4042 5.8875 16.2125C5.2125 16.0208 4.58333 15.7583 4 15.425V18.525Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipPremium);
export default __webpack_public_path__ + "static/media/membership_premium.f56f967f855ccd018c7a0f847cdcba1a.svg";
export { ForwardRef as ReactComponent };